import * as yup from 'yup';

export const percentageSchema = yup.object().shape({
  percentageForSmartphone: yup
    .number()
    .required('Porcentagem do smartphone é obrigatória')
    .max(99, 'A porcentagem não pode ser maior que 99%.')
    .typeError('Por favor, informe um número válido.'),

  percentageForAccessories: yup
    .number()
    .required('Porcentagem do acessório é obrigatória')
    .max(99, 'A porcentagem não pode ser maior que 99%.')
    .typeError('Por favor, informe um número válido.'),

  percentageForInsurance: yup
    .number()
    .required('Porcentagem do seguro é obrigatória')
    .max(99, 'A porcentagem não pode ser maior que 99%.')
    .typeError('Por favor, informe um número válido.'),
});
